import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Riders from './Riders';
import Drivers from './Drivers';
import FleetAdmins from './FleetAdmins';
import CreateAdmin from './CreateAdmin';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { makeStyles} from '@mui/styles';
import {MAIN_COLOR,SECONDORY_COLOR, FONT_FAMILY} from "../common/sharedFunctions"
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Typography } from '@mui/material';
import { ref, get, getDatabase } from 'firebase/database';

  const useStyles = makeStyles({
  tabs: {

    "& .MuiTabs-indicator": {
      backgroundColor: SECONDORY_COLOR,
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: MAIN_COLOR
    }
  },
  typography:{
    fontFamily:FONT_FAMILY
  }
})
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Users() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [managerPermissions, setManagerPermissions] = React.useState({});
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const [role, setRole] = React.useState(null);
  const classes = useStyles();
  const database = getDatabase();

  React.useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  // Load manager permissions
  React.useEffect(() => {
    const loadManagerPermissions = async () => {
      if (auth.profile && auth.profile.role === 'manager') {
        try {
          const managerRef = ref(database, "roles/manager/permissions");
          const snapshot = await get(managerRef);
          if (snapshot.exists()) {
            setManagerPermissions(snapshot.val());
          }
        } catch (error) {
          console.error("Error loading manager permissions:", error);
        }
      }
    };

    loadManagerPermissions();
  }, [auth.profile, database]);

  const handleChange = (event, newValue) => {
    navigate(`/users/${newValue}`)
  };

  // Check if user has permission for a specific user tab
  const hasUserPermission = (permissionKey) => {
    // If user is not Manager role, use existing access logic
    if (!auth.profile || auth.profile.role !== 'manager') {
      // Keep existing logic for admin/fleetadmin
      if (permissionKey === 'users_riders') {
        return true; // Both admin and fleetadmin can see riders
      }
      if (permissionKey === 'users_drivers') {
        return true; // Both admin and fleetadmin can see drivers
      }
      if (permissionKey === 'users_fleetadmins') {
        return role !== 'fleetadmin'; // Only admin can see fleetadmins
      }
      if (permissionKey === 'users_alladmin') {
        return role !== 'fleetadmin'; // Only admin can see alladmin
      }
    }
    
    // For Manager role, check database permissions
    return managerPermissions[permissionKey] === true;
  };

  React.useEffect(()=>{
    if(id && typeof(Number(id)) === "number" && Number(id)>=0 && Number(id) <=3){
      setValue(Number(id));
    }else{
      navigate("/404");
    }
  },[id,navigate])

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"  className={classes.tabs} variant="scrollable">
          {hasUserPermission('users_riders') ?
            <Tab label={ <Typography className={classes.typography}>{t('riders')}</Typography>} {...a11yProps(0)} />
          : null}
          {hasUserPermission('users_drivers') ?
            <Tab  label={ <Typography className={classes.typography}>{t('drivers')}</Typography>} {...a11yProps(1)} />
          : null}
          {hasUserPermission('users_fleetadmins') ?
            <Tab  label={ <Typography className={classes.typography}>{t('fleetadmins')}</Typography>} {...a11yProps(2)} />
          : null}
          {hasUserPermission('users_alladmin') ?
            <Tab label={ <Typography className={classes.typography}>{t('alladmin')}</Typography>} {...a11yProps(3)} />
          : null}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Riders/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Drivers/>
      </TabPanel>
        <TabPanel value={value} index={2}>
          <FleetAdmins/>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <CreateAdmin/>
        </TabPanel>
    </Box>
  );
}